<template>
  <div class="form-group esma_form_group">
    <label v-if="showLabel" v-bind:for="fieldID" class="col-xs-4 control-label esma_form_label">{{fieldLabel}}sb3</label>
    <div :class="fieldClass"  style="padding:1px 0px 1px 7px;">
      <select  class="form-control select-box select-box3"
      :style="filedStyle"
      :disabled="isDisabled"
       v-on:change="updateValue($event.target.value)"
       v-bind:id="fieldID"
       v-bind:name="fieldID"
       v-bind:value="fieldValue"
       v-on:click="onClick" >
        <option v-for="o in fieldOptions" :selected="o==fieldValue" v-bind:data="o" v-bind:key="o" val=".">{{specialLabels(o)}}</option>
        <option value="manual_input">手入力</option>
      </select>
    </div>
    <input-modal :tag="'showInputModal' + fieldID"
    @inputed="onManualSelect"></input-modal>
  </div>
</template>
<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import debug from "debug";
var debug_select = debug("__esma:select-box3");
import constants from '../../rules/constants';
import inputModal from "@/components/modals/input-modal";
Vue.component("input-modal", inputModal);
export default {
  data() {
    return {
      local_options: [],
      selection_rules: false,
      listen_for: false,
      forced_options: null,
      value_updated:false,
      last_disabled_status:true
    };
  },
  methods: {

    specialLabels(v){
        return v;
    },
    onClick() {
      // debug_select("onClick")
    },
    onManualSelect(val){
        this.value_updated = true;
        console.log("onManualSelect in > ", val)
        if (typeof this.$props.data.global_emit != "undefined") {
          console.log("onManualSelect in (not undefined)> ", val)
          bus.$emit(this.$props.data.global_emit, val);
        }
        this.$store.state[this.stateCurrentEditing][this.fieldID] = val;
        this.$store.state[this.stateCurrentRow][this.fieldID] = val;
        this.checkToApplySelectionRules(val);
        this.refreshOptions();
    },
    updateValue(d) {
      this.value_updated = true;
      // debug_select("updateValue",d)
      if(d == "manual_input"){
        console.log("manual_input INPUT");
          bus.$emit("showInputModal" + this.fieldID, {
            title:this.fieldLabel + "手入力",
            initial_value:this.$store.state[this.stateCurrentRow][this.fieldID]
          });
      }else{
        console.log("manual_input out")
        if (typeof this.$props.data.global_emit != "undefined") {
          console.log("manual_input IN")
          bus.$emit(this.$props.data.global_emit, d);
        }
        this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
        this.checkToApplySelectionRules(d);
      }
      if(this.$props.data.emit_input == true){
        this.$emit("on_update",{field:this.fieldID,val:d});
      }
    },
    getOption(name, def) {
      //debug_select("getOption",name,def)
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    },
    onReceiveEvents(ev, data) {
      // debug_select("onReceiveEvents my id ",this.$props.data.id,"Event",ev,"Data",data)
      if (ev.mode == "select_only") {
        debug_select("RECEIVING '", this.$props.data.id, "' set only '", data.allow, "' as requested by '", ev.name,"'");
        this.forced_options = data.allow;
        if(data.allow && data.allow.length == 1 && data.allow[0] ==""){
          this.$store.state[this.stateCurrentRow][this.$props.data.id] = "";
          this.$store.state[this.stateCurrentEditing][this.$props.data.id] = "";
        }
      }
    },
    checkToApplySelectionRules(selected) {
      debug_select("checkToApplySelectionRules for (start)",selected, this.selection_rules)
      if (this.selection_rules != false) {
        debug_select("checkToApplySelectionRules for (in)",selected)
        this.selection_rules.forEach(rule => {
          if (rule.action == "select_only" && rule.mode == "on_select") {
            var allow = rule.options[selected] || null;
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, {allow,from: this.$props.data.id});
            bus.$emit(rule.event_name, { allow, from: this.$props.data.id });
          } else if (rule.action == "enable_if_match_or_empty" && rule.mode == "on_select") {
            debug_select("checkToApplySelectionRules EMITING ", rule.event_name, {selected,id: this.fieldID});
            bus.$emit(rule.event_name, { selected, id: this.fieldID });
          }
        });
      }
    },
    refreshOptions(){
      var temp = _.clone(this.local_options)
      this.local_options = [];
      temp.forEach(e=>{
        this.local_options.push(e)
      })
    }
  },
  mounted() {
    this.$props.data.ref_field = this;
    // debug_select("mounted")
    if (typeof this.$props.data.selection_rules != "undefined" && this.$props.data.selection_rules.length > 0) {
      // debug_select("set selection_rules")
      this.selection_rules = this.$props.data.selection_rules;
    }
    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(e => {
        // debug_select("mounted set listen_for ",e)
        bus.$off(e.name).$on(e.name, data => {
          this.onReceiveEvents(e, data);
        });
      });
    }
  },
  computed: {
    filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || ";color:black;";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        return this.$props.data.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        return this.$props.data.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldOptions() {
      var base_options = this.$props.data.options;
      if(typeof this.$props.data.from_local_storage != "undefiend" && this.$props.data.from_local_storage &&
      this.$props.data.from_local_storage.length > 0){
        var ls = Vue.localStorage.get(this.$props.data.from_local_storage);
        var default_val = Vue.localStorage.get(this.$props.data.default_from_local_storage);
        if(default_val == constants.COMPANY.ALL){
            default_val = "";
          }
        if(ls && ls.length > 0){
          base_options = [];
          JSON.parse(ls).forEach(v=>{
            base_options.push(v.value);
            if(default_val && default_val.length > 0 && v.value == default_val && this.value_updated == false){
              setTimeout(()=>{
                  if(this.fieldValue == ""){ // FIXME: , should be only for new
                    this.updateValue("");
                    this.$store.state[this.stateCurrentRow][this.fieldID] = default_val;
                    this.updateValue(default_val);
                    this.refreshOptions();
                  }
              },100);
            }
          })
        }
      }


      debug_select("base_options", base_options);

      if (this.forced_options != null && this.isDisabled == false) {
        debug_select("field Options using forced options", this.forced_options);
        base_options = this.forced_options;
      } else {
        debug_select("field Options using normal options", this.forced_options, base_options);
      }
      this.local_options = [];
      base_options.forEach(d => {
        this.local_options.push(d);
      });
      if (this.local_options.indexOf(this.fieldValue) < 0) {
       debug_select("field Options step 1",this.fieldValue);
        if (this.forced_options == null) {
         debug_select("field Options step 2",this.fieldValue);
          this.local_options.unshift(this.fieldValue);
        } else {
         debug_select("field Options step 3", this.fieldID);
          this.$store.state[this.stateCurrentRow][this.fieldID] = "";
        }
      }
      if(this.local_options.indexOf("") < 0 && this.fieldValue != "" && this.fieldValue != null){
        this.local_options.unshift("");
      }
      debug_select("field Options using FINAL options", {forced_options:this.forced_options,local_options:this.local_options});
      return this.local_options;
    },
    fieldLabel() {
      return this.$props.data.label;
    },
    fieldValue() {
      var val = this.$store.state[this.stateCurrentRow][this.fieldID];
      if (this.local_options.indexOf(val) < 0) {
        if (this.forced_options == null) {
          this.local_options.unshift(val);
        } else {
          this.$store.state[this.stateCurrentRow][this.fieldID] = "";
        }
      }
      return this.$store.state[this.stateCurrentRow][this.fieldID];
    },
    fieldID() {
      return this.$props.data.id;
    },
    fieldClass() {
      if (this.getOption("hide_label", false) == true) {
        return "col-xs-12";
      } else {
        return "col-xs-8";
      }
    },
    showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    isDisabled() {
      var ret = null;
      if (this.$store.state[this.stateIsEditingNew] == true) {
        ret = this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"; //TODO, can also has another field to force it.
      } else {
        ret = this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
      }
      if (ret == false) {
        this.checkToApplySelectionRules(this.$store.state[this.stateCurrentRow][this.fieldID]);
      }
      if(this.last_disabled_status != ret){
        this.last_disabled_status = ret;
        this.value_updated = false;
      }
      return ret;
    }
  },
  props: ["data", "value", "option", "read"]
};
</script>
<style scoped>

.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: #cccccc;

  padding: 0px 6px 0px 6px;
}
.form-control {
  color: black;
  height: 24px;

  padding: 0px 6px 0px 6px;
}
.form-control::selection {
  color: white;
  background: #575757;
}
</style>


// WEBPACK FOOTER //
// select-box3.vue?5f7b497a